import React, { useState } from 'react'
import '../styles/layout/Home.css'
import { Container, Modal } from 'react-bootstrap';
import PlayArrowRoundedIcon from '@mui/icons-material/PlayArrowRounded';

const VIDEO_ID = 'XCa2zgwxZKQ'
const VIDEO_TITLE = 'Beyond the boundaries; A brief to 42 Card Solutions'

const About = () => {
  const [playing, setPlaying] = useState(false)

  return (
    <section className="section section--defer about">
      <Container>
        <div className="about__grid">
          <h2 className="about__title reveal">
            Partner with 42 Card Solutions to make your bank everyone’s choice for Credit Cards!
          </h2>
          <div className="about__aside reveal" data-delay="1">
            <p className="about__text">
              Credit Cards are one of the most profitable offerings in a bank’s product portfolio.
              Let a team of seasoned bankers at 42 Card Solutions manage this business for you in
              a manner that not only makes economic sense for your bank but also helps you deliver
              best-in-class experience for your customers in terms of quality, timeliness and user
              interface.
            </p>

            {/* The film opens in a dialog rather than sitting heavy on the page */}
            <button
              type="button"
              className="videoTrigger"
              onClick={() => setPlaying(true)}
              aria-label={VIDEO_TITLE}
            >
              <span
                className="videoTrigger__thumb"
                style={{ backgroundImage: `url(https://img.youtube.com/vi/${VIDEO_ID}/maxresdefault.jpg)` }}
              />
              <span className="videoTrigger__play" aria-hidden="true">
                <PlayArrowRoundedIcon />
              </span>
            </button>
          </div>
        </div>
      </Container>

      <Modal
        show={playing}
        onHide={() => setPlaying(false)}
        size="xl"
        centered
        className="video-modal"
        contentClassName="video-modal__content"
        aria-label={VIDEO_TITLE}
      >
        <Modal.Header closeButton />
        <Modal.Body>
          <div className="video-modal__frame">
            {/* Mounted only while open so playback stops on close */}
            {playing && (
              <iframe
                src={`https://www.youtube.com/embed/${VIDEO_ID}?autoplay=1&rel=0`}
                title={VIDEO_TITLE}
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen>
              </iframe>
            )}
          </div>
        </Modal.Body>
      </Modal>
    </section>
  )
}

export default About
